import { useState } from "react";

export const useObjectList = () => {
  // 重機/その他の切り替え
  const [target, setTarget] = useState<"machine" | "other">("machine");

  // 重機の状態：すべて/稼働中/待機中
  const [machineStatus, setMachineStatus] = useState<"all" | "inOperation" | "waiting">("all");

  return {
    target,
    setTarget,
    machineStatus,
    setMachineStatus,
  };
};
